export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/options-switch/OptionsSwitch.tsx"